export const GET_PERFIL = 'GET_PERFIL';
export const GET_PERFIL_SUCCESS = 'GET_PERFIL_SUCCESS';
export const GET_PERFIL_ERROR = 'GET_PERFIL_ERROR';
export const UPDATE_PERFIL = 'UPDATE_PERFIL';
export const UPDATE_PERFIL_SUCCESS = 'UPDATE_PERFIL_SUCCESS';
export const UPDATE_PERFIL_ERROR = 'UPDATE_PERFIL_ERROR';
export const SET_LOAD_PROFILE_OFF = 'SET_LOAD_PROFILE_OFF';
